<div class="absolute inset-0 z-40 bg-black opacity-50"></div>
<div class="absolute inset-0 z-40 grid place-items-end px-4 pb-6 md:place-items-center md:p-0">
  <div class="grid max-w-[425px] rounded-3xl bg-white p-6">
    <h1 class="prose-display-lg font-semibold" translate>{{ msg }}</h1>
    <div class="pb-3"></div>
    <span *ngIf="status + '' === '453'" class="text-neutral-500" translate
      >msg.idExpiredForceLogoutMsg</span
    >
    <ng-template #idExpiring>
      <span class="text-neutral-500" translate>msg.idExpiredForceLogoutMsg</span>
    </ng-template>
    <div class="pb-10"></div>
    <button
      app-button
      color="secondary"
      *ngIf="status + '' === '453'"
      (click)="logOut()"
      translate>
      btn.log_out
    </button>
  </div>
</div>
